import { ACTIONS } from '../config/constants';

export default (state = null, action) => {
  switch (action.type) {
    case ACTIONS.TYPES.TAG.GET_SUCCESS: {
      return action.tags;
    }
    case ACTIONS.TYPES.TAG.GET_ERROR: {
      return action.error;
    }
    case ACTIONS.TYPES.TAG.UPDATE: {
      return action.tags;
    }
    case ACTIONS.TYPES.TAG.GET_INITIALIZED: {
      return { tagsLoading: true };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/tags.reducer.js